import styled from "styled-components";

export const Card = styled.div`
  text-align: left;
  border-radius: 5px;
  padding: 15px;
  height: 100%;
  box-shadow:
    rgb(0 0 0 / 10%) 0px 0.1875rem 0.375rem,
    rgb(0 0 0 / 16%) 0px 0.1875rem 0.375rem;
`;
